import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import app from './modules/app'
import purchasing from './modules/purchasing'

Vue.use(Vuex)

const _store = new Vuex.Store({
    modules: {
        app,
        user,
        purchasing,
    },
})

export default _store
